import { render, staticRenderFns } from "./IndicadoresHistoricoComprasVentas.vue?vue&type=template&id=5a392818&"
import script from "./IndicadoresHistoricoComprasVentas.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoComprasVentas.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresHistoricoComprasVentas.vue?vue&type=style&index=0&id=5a392818&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports